import { Component, OnInit, ViewChild } from '@angular/core';
import { DxDataGridComponent } from 'devextreme-angular';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ArkUnitOfWork } from '../../core/core.module';
import { UserDetailComponent } from '../user-detail/user-detail.component';
import moment from 'moment';
import { SharedModule } from 'app/shared/shared.module';

@Component({
    selector: 'app-login-overview',
    templateUrl: './login-overview.component.html',
    styleUrls: ['./login-overview.component.scss'],
    standalone: false,
})
export class LoginOverviewComponent implements OnInit {
    users: any[] = [];
    entities: any;
    filter: any;
    showAll = false;

    onToolbarPreparing = SharedModule.onToolbarPreparing;

    constructor(private uow: ArkUnitOfWork, private modalService: BsModalService) {}

    async ngOnInit() {
        await this.getData();
        this.filter = {};
    }

    async getData() {
        const entities = await this.uow.getLogins();
        // entities.forEach((entity: any) => {
            // entity.createdDate = moment(entity.created).utcOffset('Eastern').toDate();
        // });
        this.entities = entities;
    }
}
